import type {
	VoucherIssuedForCampaignListByHotelIdAndVoucherId_DetailsPageQuery,
	VoucherIssuedMarkVoucherAsUnUsedInput,
	VoucherIssuedMarkVoucherAsUsedInput,
} from "@/lib/gql/__generated__/graphql";

import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table/table";

import { CampaignDetailsInnerHeader } from "./innner-header";
import { CampaignDetailsItem } from "./item";

type Props = {
	hotelID: string;
	data: VoucherIssuedForCampaignListByHotelIdAndVoucherId_DetailsPageQuery;
	onUpdateMarkVoucherAsUnUsed: (input: VoucherIssuedMarkVoucherAsUnUsedInput) => Promise<boolean>;
	onUpdateMarkVoucherAsUsed: (input: VoucherIssuedMarkVoucherAsUsedInput) => Promise<boolean>;
};

export const CampaignDetails = ({ hotelID, data, onUpdateMarkVoucherAsUnUsed, onUpdateMarkVoucherAsUsed }: Props) => {
	const { voucherForCampaign, voucherIssuedForCampaignListByHotelIDAndVoucherID } = data;
	const { voucherIssuedForCampaignList } = voucherIssuedForCampaignListByHotelIDAndVoucherID;

	return (
		<FeatureIslandMainWithBackGround islandTitle="送付者リスト">
			<CampaignDetailsInnerHeader
				voucherForCampaign={voucherForCampaign}
				voucherIssuedForCampaignList={voucherIssuedForCampaignList}
			/>
			<div className="overflow-x-auto">
				<Table>
					<TableHeader>
						<TableRow>
							<TableHead>ステータス</TableHead>
							<TableHead>ID</TableHead>
							<TableHead>名前</TableHead>
							<TableHead>メールアドレス</TableHead>
							<TableHead>予約ID</TableHead>
							<TableHead>ゲストにシェアされるURL</TableHead>
						</TableRow>
					</TableHeader>
					<TableBody>
						{voucherIssuedForCampaignList.length ? (
							voucherIssuedForCampaignList.map((item, idx) => {
								return (
									<CampaignDetailsItem
										key={idx}
										hotelID={hotelID}
										campaignItem={item}
										onUpdateMarkVoucherAsUnUsed={onUpdateMarkVoucherAsUnUsed}
										onUpdateMarkVoucherAsUsed={onUpdateMarkVoucherAsUsed}
									/>
								);
							})
						) : (
							<TableRow>
								<TableCell>発行されたキャンペーンはありません</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</div>
		</FeatureIslandMainWithBackGround>
	);
};

CampaignDetails.displayName = "CampaignDetails";
